import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
 * Jola Inetractive
 *
 * @copyright 2023 © All rights Reserved.
 * @authtor jelena.radovanovic@jolausa.com
 */
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { KlevuKMCSettings, KlevuSearchSorting, listFilters, overrideSettings, applyFilterWithManager, KlevuFetch, KlevuDomEvents, FilterManager, search, KlevuResultEvent, sendSearchEvent, personalisation, applyFilters, boostWithFilters, debug, KlevuFilterOrder, sendMerchandisingViewEvent, categoryMerchandising, KlevuEvents, abTest } from '@klevu/core';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { KlevuEventV1CategoryProductClick } from './KlevuV1Events';
import { fieldSearchLoggedIn, fieldSearchNonLoggedIn, KLEVU_FORMAT_PRODUCTS, KLEVU_SORT_OPTIONS_LOGGED_IN, KLEVU_SORT_OPTIONS_LOGGED_OUT, KLEVU_TRANSFORM_FILTERS } from './klevuSearchFields';
var STORAGE_KEY = "klevu-variants-data";
var STORAGE_TS_KEY = "klevu-variants-data-ts";
var STORAGE_VARIANTS_KEY = "klevu-used-variants";
var ONE_HOUR = 3600000;
var event = new Event('klevu-clear-filters');
export var rangeSliderFilters = ['klevu_price', 'hf_height', 'hf_width', 'hf_depth_length', 'hf_length'];
var prevRes;
var clickManager;
var manager = new FilterManager();
var initialSearch = new URLSearchParams(window.location.search);
var paramObj = {};

var _iterator = _createForOfIteratorHelper(initialSearch.keys()),
    _step;

try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var value = _step.value;

    if (value !== 'page' && value !== 'query') {
      paramObj[value] = initialSearch.getAll(value);
    }
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

var initialFieldsSelection = function initialFieldsSelection() {
  return Object.keys(paramObj).map(function (item, zkey) {
    var _paramObj$item;

    var key = item === null || item === void 0 ? void 0 : item.replace('[filter]', '');

    if (rangeSliderFilters.includes(key)) {
      var _paramObj$item$;

      var values = (_paramObj$item$ = paramObj[item][0]) === null || _paramObj$item$ === void 0 ? void 0 : _paramObj$item$.split('_');
      return {
        key: key,
        type: 'SLIDER',
        start: values[0],
        end: values[1]
      };
    }

    return {
      key: key,
      type: 'OPTIONS',
      options: (_paramObj$item = paramObj[item]) === null || _paramObj$item === void 0 ? void 0 : _paramObj$item.map(function (filterItem) {
        var exploded = filterItem === null || filterItem === void 0 ? void 0 : filterItem.split(/,/g);
        return {
          count: 0,
          name: exploded[0],
          value: exploded[1],
          selected: true
        };
      })
    };
  });
};

manager.initFromListFilters(initialFieldsSelection());
export var useQuery = function useQuery() {
  var _useLocation = useLocation(),
      search = _useLocation.search;

  return useMemo(function () {
    return new URLSearchParams(search);
  }, [search]);
};

var isBrowser = function isBrowser() {
  return ![typeof window === "undefined" ? "undefined" : _typeof(window), typeof document === "undefined" ? "undefined" : _typeof(document)].includes('undefined');
};

var UseKlevuSearchResults = function UseKlevuSearchResults(isSignedIn, customerGroupId) {
  var klevuQuerySettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    type: 'search',
    query: query,
    query_string: 'query',
    can_search: true,
    title: undefined
  };
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    enablePersonalisation: true
  };
  return function () {
    var _ref5;

    var query = klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query;

    var _useLocation2 = useLocation(),
        pathname = _useLocation2.pathname,
        searchLocation = _useLocation2.search;

    var history = useHistory();
    var searchParams = new URLSearchParams(searchLocation);
    var pageS = searchParams.get('pageSize');

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        open = _useState2[0],
        setOpen = _useState2[1];

    var _useState3 = useState(pageS ? Number(pageS) : 30),
        _useState4 = _slicedToArray(_useState3, 2),
        pageSize = _useState4[0],
        setPageSize = _useState4[1];

    var _useState5 = useState(manager === null || manager === void 0 ? void 0 : manager.options),
        _useState6 = _slicedToArray(_useState5, 2),
        options = _useState6[0],
        setOptions = _useState6[1];

    var _useState7 = useState(manager === null || manager === void 0 ? void 0 : manager.sliders),
        _useState8 = _slicedToArray(_useState7, 2),
        sliders = _useState8[0],
        setSliders = _useState8[1];

    var _useState9 = useState({
      items: [],
      meta: {}
    }),
        _useState10 = _slicedToArray(_useState9, 2),
        products = _useState10[0],
        setProducts = _useState10[1];

    var _useState11 = useState(KlevuSearchSorting.NewArrivalDesc),
        _useState12 = _slicedToArray(_useState11, 2),
        sorting = _useState12[0],
        setSorting = _useState12[1];

    var _useState13 = useState(false),
        _useState14 = _slicedToArray(_useState13, 2),
        showMore = _useState14[0],
        setShowMore = _useState14[1];

    var _useState15 = useState(false),
        _useState16 = _slicedToArray(_useState15, 2),
        filtersLoaded = _useState16[0],
        setFiltersLoaded = _useState16[1];

    var _useState17 = useState(),
        _useState18 = _slicedToArray(_useState17, 2),
        kmcSettings = _useState18[0],
        setKmcSettings = _useState18[1];

    var _useState19 = useState(true),
        _useState20 = _slicedToArray(_useState19, 2),
        loading = _useState20[0],
        setLoading = _useState20[1];

    var returnVariantsAndCacheData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var _categoryVariants$ass2;

        var ignoreCache,
            sourceId,
            res,
            ts,
            usedVariant,
            _allVariants$assigned,
            allUsedVariants,
            isUsedVariant,
            allVariants,
            variantExistsButNotSet,
            newAllUsedVariants,
            categoryVariants,
            _usedVariant,
            _JSON$parse,
            _categoryVariants$ass,
            usedVariants,
            allVariantsArray,
            _allVariantsArray,
            _allVariantsArray$cur,
            currentVariant,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ignoreCache = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                sourceId = query.toLowerCase();

                if (kmcSettings !== null && kmcSettings !== void 0 && kmcSettings.klevu_cmsApiKey) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 4:
                if (!(isBrowser() && window.localStorage && ignoreCache !== true)) {
                  _context.next = 20;
                  break;
                }

                res = window.localStorage.getItem('abtest-data');
                ts = window.localStorage.getItem('abtest-data-ts');
                usedVariant = window.localStorage.getItem(STORAGE_VARIANTS_KEY);

                if (!(res && ts && new Date().getTime() - parseInt(ts, 10) < ONE_HOUR)) {
                  _context.next = 20;
                  break;
                }

                allUsedVariants = usedVariant !== 'undefined' ? JSON.parse(usedVariant) : null;
                isUsedVariant = (allUsedVariants === null || allUsedVariants === void 0 ? void 0 : allUsedVariants.length) > 0 ? allUsedVariants === null || allUsedVariants === void 0 ? void 0 : allUsedVariants.find(function (abTest) {
                  return (abTest === null || abTest === void 0 ? void 0 : abTest.sourceId) === sourceId;
                }) : undefined;

                if (!isUsedVariant) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", isUsedVariant);

              case 13:
                allVariants = res !== 'undefined' ? JSON.parse(res) : null;
                variantExistsButNotSet = allVariants === null || allVariants === void 0 ? void 0 : (_allVariants$assigned = allVariants.assigned) === null || _allVariants$assigned === void 0 ? void 0 : _allVariants$assigned.find(function (abTest) {
                  return (abTest === null || abTest === void 0 ? void 0 : abTest.sourceId) === sourceId;
                });

                if (!variantExistsButNotSet) {
                  _context.next = 19;
                  break;
                }

                newAllUsedVariants = [].concat(_toConsumableArray(allUsedVariants), [variantExistsButNotSet]);
                window.localStorage.setItem(STORAGE_VARIANTS_KEY, JSON.stringify(newAllUsedVariants));
                return _context.abrupt("return", variantExistsButNotSet);

              case 19:
                return _context.abrupt("return", undefined);

              case 20:
                _context.next = 22;
                return fetch("https://config-cdn.ksearchnet.com/abtest/public/allocation/".concat(kmcSettings === null || kmcSettings === void 0 ? void 0 : kmcSettings.klevu_cmsApiKey, "/"), {
                  method: 'POST'
                }).then(function (response) {
                  return response.json();
                }, function (error) {
                  console.log(error);
                });

              case 22:
                categoryVariants = _context.sent;

                if (isBrowser() && window.localStorage) {
                  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(categoryVariants));
                  window.localStorage.setItem(STORAGE_TS_KEY, new Date().getTime().toString());
                  _usedVariant = window.localStorage.getItem(STORAGE_VARIANTS_KEY);

                  try {
                    if (!_usedVariant || ((_JSON$parse = JSON.parse(_usedVariant)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.length) === 0) {
                      usedVariants = categoryVariants === null || categoryVariants === void 0 ? void 0 : (_categoryVariants$ass = categoryVariants.assigned) === null || _categoryVariants$ass === void 0 ? void 0 : _categoryVariants$ass.map(function (item) {
                        return _objectSpread({}, item);
                      });
                      window.localStorage.setItem(STORAGE_VARIANTS_KEY, JSON.stringify(usedVariants));
                    }
                  } catch (e) {
                    console.log('invalid json');
                  }
                }

                allVariantsArray = false;

                try {
                  _allVariantsArray = window.localStorage.getItem(STORAGE_VARIANTS_KEY) ? JSON.parse(window.localStorage.getItem(STORAGE_VARIANTS_KEY)) : false;
                } catch (e) {
                  // do nothing
                  console.log(e);
                }

                if (allVariantsArray) {
                  currentVariant = allVariantsArray === null || allVariantsArray === void 0 ? void 0 : allVariantsArray.findIndex(function (abTest) {
                    return (abTest === null || abTest === void 0 ? void 0 : abTest.sourceId) === sourceId;
                  });

                  if (allVariantsArray[currentVariant] && !((_allVariantsArray$cur = allVariantsArray[currentVariant]) !== null && _allVariantsArray$cur !== void 0 && _allVariantsArray$cur.visited)) {
                    fetch("https://config-cdn.ksearchnet.com/abtest/public/usage/".concat(kmcSettings === null || kmcSettings === void 0 ? void 0 : kmcSettings.klevu_cmsApiKey, "/"), {
                      method: 'POST',
                      body: JSON.stringify(allVariantsArray[currentVariant]),
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }).then(function (result) {
                      if ((result === null || result === void 0 ? void 0 : result.status) === 200) {
                        allVariantsArray[currentVariant].visited = true;
                        window.localStorage.setItem(STORAGE_VARIANTS_KEY, JSON.stringify(allVariantsArray));
                      } else {
                        window.localStorage.setItem(STORAGE_VARIANTS_KEY, JSON.stringify(allVariantsArray === null || allVariantsArray === void 0 ? void 0 : allVariantsArray.filter(function (abTest) {
                          return (abTest === null || abTest === void 0 ? void 0 : abTest.sourceId) !== sourceId;
                        })));
                      }
                    }, function (error) {
                      console.log(error);
                    });
                  }
                }

                return _context.abrupt("return", categoryVariants === null || categoryVariants === void 0 ? void 0 : (_categoryVariants$ass2 = categoryVariants.assigned) === null || _categoryVariants$ass2 === void 0 ? void 0 : _categoryVariants$ass2.find(function (abTest) {
                  return (abTest === null || abTest === void 0 ? void 0 : abTest.sourceId) === sourceId;
                }));

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function returnVariantsAndCacheData(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var initialFetch = useCallback( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
        var _manager$options, _manager$options$filt, _manager$sliders, _manager$sliders$map, _ref3, _searchResult$records;

        var categoryVariants, selectedFilters, selectedSliderFilter, optionsBasedOnQuery, hashTable, _iterator2, _step2, option, key, _option$, newKey, _value, _currentOptions$value, currentOptions, optionObject, _option$2, range, rangeFilter, filtersWithManager, applyAllFilters, modifiers, functions, res, searchResult, productsResults;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading(true);

                if (!(!(klevuQuerySettings !== null && klevuQuerySettings !== void 0 && klevuQuerySettings.query_string) && !(klevuQuerySettings !== null && klevuQuerySettings !== void 0 && klevuQuerySettings.can_search))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                if (!((klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string) === 'Outlet')) {
                  _context2.next = 7;
                  break;
                }

                setLoading(false);
                setProducts([]);
                return _context2.abrupt("return");

              case 7:
                _context2.next = 9;
                return returnVariantsAndCacheData(klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string);

              case 9:
                categoryVariants = _context2.sent;
                // const initialSearch = new URLSearchParams(window.location.search);
                selectedFilters = manager === null || manager === void 0 ? void 0 : (_manager$options = manager.options) === null || _manager$options === void 0 ? void 0 : (_manager$options$filt = _manager$options.filter(function (item) {
                  var attributeInQuery = query.getAll((item === null || item === void 0 ? void 0 : item.key) + '[filter]');
                  return (attributeInQuery === null || attributeInQuery === void 0 ? void 0 : attributeInQuery.length) > 0;
                })) === null || _manager$options$filt === void 0 ? void 0 : _manager$options$filt.map(function (item) {
                  var _item$options, _item$options$filter;

                  var attributeInQuery = query.getAll((item === null || item === void 0 ? void 0 : item.key) + '[filter]');
                  var filteredOptions = item === null || item === void 0 ? void 0 : (_item$options = item.options) === null || _item$options === void 0 ? void 0 : (_item$options$filter = _item$options.filter(function (o) {
                    var _o$name, _parseFloat, _parseFloat$toFixed, _parseFloat$toFixed$r;

                    var value = o !== null && o !== void 0 && (_o$name = o.name) !== null && _o$name !== void 0 && _o$name.includes('000') ? ((_parseFloat = parseFloat(o === null || o === void 0 ? void 0 : o.name)) === null || _parseFloat === void 0 ? void 0 : (_parseFloat$toFixed = _parseFloat.toFixed(2)) === null || _parseFloat$toFixed === void 0 ? void 0 : (_parseFloat$toFixed$r = _parseFloat$toFixed.replace(/0$/, '')) === null || _parseFloat$toFixed$r === void 0 ? void 0 : _parseFloat$toFixed$r.replace(/\.0$/, '').toString()) + '"' : o === null || o === void 0 ? void 0 : o.name;
                    return attributeInQuery === null || attributeInQuery === void 0 ? void 0 : attributeInQuery.includes(value + ',' + (o === null || o === void 0 ? void 0 : o.value));
                  })) === null || _item$options$filter === void 0 ? void 0 : _item$options$filter.map(function (o) {
                    return o;
                  });
                  var filteredOptionsValues = filteredOptions.map(function (item) {
                    return item === null || item === void 0 ? void 0 : item.value;
                  });
                  var klevuFilterRequest = {};

                  if (!rangeSliderFilters.includes(item === null || item === void 0 ? void 0 : item.key)) {
                    klevuFilterRequest = {
                      key: item === null || item === void 0 ? void 0 : item.key,
                      values: filteredOptionsValues,
                      settings: {
                        singleSelect: false
                      }
                    };
                  }

                  return klevuFilterRequest;
                });
                selectedSliderFilter = manager === null || manager === void 0 ? void 0 : (_manager$sliders = manager.sliders) === null || _manager$sliders === void 0 ? void 0 : (_manager$sliders$map = _manager$sliders.map(function (x) {
                  if (!(x !== null && x !== void 0 && x.start) && !(x !== null && x !== void 0 && x.end)) return;
                  return {
                    key: x === null || x === void 0 ? void 0 : x.key,
                    values: [x === null || x === void 0 ? void 0 : x.start, x === null || x === void 0 ? void 0 : x.end],
                    settings: {
                      singleSelect: false
                    }
                  };
                })) === null || _manager$sliders$map === void 0 ? void 0 : _manager$sliders$map.filter(function (x) {
                  return x !== undefined;
                }); // const filtersBasedOnQuery = rangeSliderFilters
                //     ?.map(range => {
                //         const filterIsActive = query?.get(range + '[filter]');
                //         if (filterIsActive) {
                //             return {
                //                 key: range,
                //                 values: filterIsActive?.split('_'),
                //                 settings: {
                //                     singleSelect: false
                //                 }
                //             };
                //         }
                //     })
                //     ?.filter(x => x);

                optionsBasedOnQuery = [];
                hashTable = {};
                _iterator2 = _createForOfIteratorHelper(query);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    option = _step2.value;
                    key = option[0];

                    if (key !== null && key !== void 0 && key.includes('[filter]') && !(rangeSliderFilters !== null && rangeSliderFilters !== void 0 && rangeSliderFilters.includes(key === null || key === void 0 ? void 0 : key.replace('[filter]', '')))) {
                      newKey = key === null || key === void 0 ? void 0 : key.replace('[filter]', '');
                      _value = (_option$ = option[1]) === null || _option$ === void 0 ? void 0 : _option$.split(',')[1];

                      if (hashTable[newKey]) {
                        currentOptions = optionsBasedOnQuery[hashTable[newKey]];
                        currentOptions === null || currentOptions === void 0 ? void 0 : (_currentOptions$value = currentOptions.values) === null || _currentOptions$value === void 0 ? void 0 : _currentOptions$value.push(_value);
                        optionsBasedOnQuery[hashTable[newKey]] = currentOptions;
                      } else {
                        optionObject = {
                          key: newKey,
                          values: [_value],
                          settings: {
                            singleSelect: false
                          }
                        };
                        optionsBasedOnQuery.push(optionObject);
                        hashTable[newKey] = (optionsBasedOnQuery === null || optionsBasedOnQuery === void 0 ? void 0 : optionsBasedOnQuery.length) - 1;
                      }
                    } else {
                      if (key !== null && key !== void 0 && key.includes('[filter]')) {
                        range = (_option$2 = option[1]) === null || _option$2 === void 0 ? void 0 : _option$2.split('_');
                        rangeFilter = {
                          key: key === null || key === void 0 ? void 0 : key.replace('[filter]', ''),
                          values: range,
                          settings: {
                            singleSelect: false
                          }
                        };
                        optionsBasedOnQuery.push(rangeFilter);
                      }
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                filtersWithManager = applyFilterWithManager(manager);
                applyAllFilters = applyFilters((_ref3 = [].concat(optionsBasedOnQuery)) === null || _ref3 === void 0 ? void 0 : _ref3.filter(function (x) {
                  return x !== undefined;
                }));
                modifiers = [listFilters({
                  enabled: true,
                  include: ['category', 'hf_diameter', 'hf_dimensions', 'hf_fixutre_shape', 'hf_led_boolean', 'hf_led_bool', 'hf_style', 'hf_location_rating_ul', 'hf_new_designs', 'hf_sloped_ceiling_bool', 'hf_dark_sky_friendly', 'hf_overall_height', 'hf_fixture_shape', 'hf_adacompliant', 'hf_best_seller', 'hf_designer_preference'],
                  rangeFilterSettings: rangeSliderFilters === null || rangeSliderFilters === void 0 ? void 0 : rangeSliderFilters.map(function (range) {
                    return {
                      key: range,
                      minMax: true
                    };
                  }),
                  order: KlevuFilterOrder.Frequency,
                  limit: 10,
                  mincount: 1,
                  filterManager: manager
                }), applyAllFilters, // applyFilters(selectedFilters),
                // applyFilterWithManager(manager),
                (klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.type) === 'search' ? sendSearchEvent() : (klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.type) === 'category' ? sendMerchandisingViewEvent(klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.title) : function () {} // debug()
                ];

                if (props.personlisationEnabled) {
                  modifiers.push(personalisation());
                } // if (pathname == '/search.html') {
                //     modifiers.push(overrideSettings({'customANDQuery': '-(klevu_category:"Outlet") OR -(hf_is_outlet:"Yes")'}));
                // }


                functions = [(klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.type) === 'search' ? search.apply(void 0, [query.get(klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string), {
                  id: 'search',
                  limit: pageSize,
                  sort: sorting,
                  priceFieldSuffix: customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null,
                  //   visibilityGroupID: isSignedIn ? '12' : '0',
                  offset: query.get('page') ? query.get('page') === '1' ? 0 : (query.get('page') - 1) * pageSize : 0,
                  fields: isSignedIn ? fieldSearchLoggedIn : fieldSearchNonLoggedIn
                }].concat(modifiers)) : categoryMerchandising.apply(void 0, [klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string.toLowerCase(), {
                  abTestId: categoryVariants === null || categoryVariants === void 0 ? void 0 : categoryVariants.abTestId,
                  abTestVariantId: categoryVariants === null || categoryVariants === void 0 ? void 0 : categoryVariants.abTestVariantId,
                  id: 'search',
                  limit: pageSize,
                  sort: sorting,
                  priceFieldSuffix: customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null,
                  //   visibilityGroupID: isSignedIn ? '12' : '0',
                  offset: query.get('page') ? query.get('page') === '1' ? 0 : (query.get('page') - 1) * pageSize : 0,
                  fields: isSignedIn ? fieldSearchLoggedIn : fieldSearchNonLoggedIn
                }].concat(modifiers))];
                _context2.next = 23;
                return KlevuFetch.apply(void 0, functions);

              case 23:
                res = _context2.sent;
                prevRes = res;
                searchResult = res.queriesById('search');

                if (searchResult) {
                  _context2.next = 28;
                  break;
                }

                return _context2.abrupt("return");

              case 28:
                clickManager = query.get(klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string) ? searchResult.getSearchClickSendEvent() : searchResult.getCategoryMerchandisingClickSendEvent();
                setShowMore(Boolean(res.next));
                setOptions(manager === null || manager === void 0 ? void 0 : manager.options);
                setSliders(manager === null || manager === void 0 ? void 0 : manager.sliders);
                productsResults = searchResult === null || searchResult === void 0 ? void 0 : (_searchResult$records = searchResult.records) === null || _searchResult$records === void 0 ? void 0 : _searchResult$records.map(function (r) {
                  var _r$image, _r$imageUrl, _r$imageUrl$replace, _r$imageUrl$replace$r;

                  var image = r === null || r === void 0 ? void 0 : (_r$image = r.image) === null || _r$image === void 0 ? void 0 : _r$image.replace(/.*?\/needtochange/, '');
                  var imageUrl = r === null || r === void 0 ? void 0 : (_r$imageUrl = r.imageUrl) === null || _r$imageUrl === void 0 ? void 0 : (_r$imageUrl$replace = _r$imageUrl.replace(/.*?\/needtochange/, '')) === null || _r$imageUrl$replace === void 0 ? void 0 : (_r$imageUrl$replace$r = _r$imageUrl$replace.replace('/media/klevu_images/200X200', '')) === null || _r$imageUrl$replace$r === void 0 ? void 0 : _r$imageUrl$replace$r.replace('needtochange', 'media/catalog/product');
                  return _objectSpread(_objectSpread({}, r), {}, {
                    image: image,
                    imageUrl: imageUrl,
                    url: r.url.replace(process.env.MAGENTO_BACKEND_URL + '/', ''),
                    clickManager: clickManager,
                    categoryVariant: categoryVariants === null || categoryVariants === void 0 ? void 0 : categoryVariants.abTestVariantId,
                    categoryPath: klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string,
                    categoryTitle: klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.title,
                    klevuApi: kmcSettings === null || kmcSettings === void 0 ? void 0 : kmcSettings.klevu_cmsApiKey,
                    abTestId: categoryVariants === null || categoryVariants === void 0 ? void 0 : categoryVariants.abTestId,
                    abTestVariantId: categoryVariants === null || categoryVariants === void 0 ? void 0 : categoryVariants.abTestVariantId
                  });
                });
                setProducts(productsResults ? {
                  items: productsResults,
                  meta: searchResult === null || searchResult === void 0 ? void 0 : searchResult.meta
                } : []);
                setLoading(false);

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }(), [sorting, klevuQuerySettings, klevuQuerySettings.can_search, klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.type, pageSize]); // const fetchMore = async () => {
    //     const nextRes = await prevRes.next({
    //         filterManager: manager
    //     });
    //     setProducts([
    //         ...products,
    //         ...(nextRes.queriesById('search')?.records
    //             ? nextRes.queriesById('search')?.records
    //             : [])
    //     ]);
    //     prevRes = nextRes;
    //     setShowMore(Boolean(nextRes.next));
    // };

    var fetchKMCSettings = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var settings;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return KlevuKMCSettings();

            case 2:
              settings = _context3.sent;
              setKmcSettings(settings.root);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })), []);
    useEffect(function () {
      fetchKMCSettings();
    }, []);
    var handleFilterUpdate = useCallback(function () {
      initialFetch(query);
    }, [query, klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.type, klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string, isSignedIn, customerGroupId, pageSize]);
    useEffect(function () {
      document.addEventListener(KlevuDomEvents.FilterSelectionUpdate, handleFilterUpdate); // cleanup this component

      return function () {
        document.removeEventListener(KlevuDomEvents.FilterSelectionUpdate, handleFilterUpdate);
      };
    }, []);
    var setFiltersLoadedHandler = useCallback(setFiltersLoaded, [setFiltersLoaded]);
    useEffect(function () {
      initialFetch(query);
    }, [query, sorting, isSignedIn, filtersLoaded, klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.type, klevuQuerySettings === null || klevuQuerySettings === void 0 ? void 0 : klevuQuerySettings.query_string, customerGroupId, pageSize]);
    var transformedProductsArray = useMemo(function () {
      return KLEVU_FORMAT_PRODUCTS(products, customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null);
    }, [products, customerGroupId]);
    var klevuSortingOptions = useMemo(function () {
      return isSignedIn ? KLEVU_SORT_OPTIONS_LOGGED_IN : KLEVU_SORT_OPTIONS_LOGGED_OUT;
    }, [isSignedIn]);
    var transformedFilters = useMemo(function () {
      return KLEVU_TRANSFORM_FILTERS(options, sliders, manager);
    }, [options, manager, sliders]);
    var setPageSizeCallback = useCallback(function (pageSize) {
      var queryParameters = new URLSearchParams(window.location.search);
      queryParameters.set('page', 1);
      queryParameters.set('pageSize', pageSize);
      setPageSize(pageSize);
      history.push({
        pathname: window.location.pathname,
        search: queryParameters.toString()
      });
    }, [setPageSize]);
    return _ref5 = {
      products: products,
      magentoProducts: transformedProductsArray,
      sorting: sorting,
      setSorting: setSorting,
      showMore: showMore,
      open: open,
      options: transformedFilters,
      sliders: sliders,
      clickManager: clickManager,
      manager: manager,
      klevuSortingOptions: klevuSortingOptions
    }, _defineProperty(_ref5, "sorting", sorting), _defineProperty(_ref5, "setSorting", setSorting), _defineProperty(_ref5, "query", query), _defineProperty(_ref5, "klevuLoading", loading), _defineProperty(_ref5, "initialFetch", initialFetch), _defineProperty(_ref5, "pageSize", pageSize), _defineProperty(_ref5, "setPageSize", setPageSizeCallback), _ref5;
  }();
};

export default UseKlevuSearchResults;